import { createSlice } from "@reduxjs/toolkit";

const usersSlice = createSlice({
  name: "users",
  initialState: {
    data: [],
    totalRecords: 0,
    isLoading: false,
    error: null,
  },
  reducers: {
    setUsers(state, action) {
      state.data = action.payload.data || [];
      state.totalRecords = action.payload.total || 0;
      state.isLoading = false;
    },
    setLoading(state, action) {
      state.isLoading = action.payload;
    },
    setError(state, action) {
      state.error = action.payload;
      state.isLoading = false;
    },
  },
});

export const { setUsers, setLoading, setError } = usersSlice.actions;
export default usersSlice.reducer;
